import styled from 'styled-components'

export const PCWTCContainer = styled.div`
  width: 100%;
  overflow: scroll;
  display: flex;
  justify-content: left;
  padding: 20px;
  gap: 10px;
  -webkit-overflow-scrolling: touch; /* For iOS devices */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  @media (min-width: 568px) {
    gap: 20px;
    padding: 35px;
  }
  @media (min-width: 768px) {
    justify-content: center;
    gap: 50px;
    padding: 35px;
  }
`

export const PCWTCPlanContainer = styled.button`
  display: flex;
  flex: 0 0 175px;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 5px;
  }
  text-decoration: none;
  @media (min-width: 568px) {
    flex: 0 0 225px;
    padding: 35px;
  }
  @media (min-width: 768px) {
    flex: 0 0 350px;
    padding: 35px;
  }
`

export const PCWTCPremadePlanText = styled.div`
  text-align: center;
  color: ${(props) => (props?.dark ? '#495064' : '#FFF')};
  font-weight: ${(props) => (props?.bolder ? '500' : '400')};
  font-family: ${(props) => (props?.specialFont ? 'Nothing You Could Do' : 'Outfit')};
  ${(props) => props?.specialFont && 'margin-top: 10px;'};
  ${(props) => props?.specialFont && 'transform: rotate(-5deg);'};
  font-size: 20px;
  ${(props) => props?.specialFont && 'font-size: 24px;'};
  @media (min-width: 768px) {
    font-size: 28px;
    ${(props) => props?.specialFont && 'font-size: 32px;'};
  }
`

export const PCWTCSeparator = styled.div`
  width: 2px;
  height: auto;
  border-left: 1px dashed #eae2f6;
`

export const PCWTCImage = styled.img`
  width: 100px;
  border-radius: 8px;
  margin-bottom: 10px;
`
